/** Class strings the navbar pieces share (tokens only; docs/design/MASTER.md sections 3 to 5). */

/** A link or button row inside a desktop header panel. */
export const PANEL_LINK =
  "flex min-h-10 items-center gap-2 rounded-control px-3 text-sm text-foreground transition-colors duration-150 hover:bg-secondary";

/**
 * The phone header's Menu button and the phone menu's Close button. They sit in the same spot and share one size,
 * so opening the menu changes the label and icon and nothing moves. Below 360px the word hides (it stays as the
 * button's name for screen readers) so the logo and both buttons fit on a 320px screen.
 */
export const MENU_TOGGLE =
  "inline-flex h-11 w-[5.75rem] shrink-0 items-center justify-center gap-2 rounded-control border border-border bg-background text-sm font-medium text-foreground transition-colors duration-150 hover:bg-secondary active:bg-secondary max-[359px]:w-11";

/** The square 44px icon buttons in the header (search on phones, the theme toggle on desktop). */
export const ICON_BUTTON =
  "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-control text-muted-foreground transition-colors duration-150 hover:bg-secondary hover:text-foreground";
